import React, { useEffect, useState } from 'react';
import localRequest from '../services/LocalServer/localRequest';
import PingPad from './items/Pingpad';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import useLongPress from './items/useLongPress';

export default function OutOfOrder(props) {
  const history = useHistory();
  const machineID = localStorage.getItem('machineID');
  const testMode = localStorage.getItem('testMode') === 'true' ? 'true' : 'false';
  const linkToURL = `/machineUI/home/${machineID}/${testMode}`;
  const powerOption = localStorage.getItem('OUT_OF_STOCK_ON_POWEWOFF') === 'TRUE';
  const [show, setShow] = useState(false);
  const [showPingPad, setShowPingPad] = useState(false);
  const [content, setContent] = useState(
    <div className="out-of-stock">Sorry, this kiosk is temporarily unavailable.</div>
  );

  useEffect(() => {
    setContent(<div className="out-of-stock">Sorry, this kiosk is temporarily unavailable.</div>);
  }, []);

  // Initialize the useLongPress hook with 2000ms (2 seconds)
  const longPressEvent = useLongPress()(() => {
    if (powerOption) {
      setShowPingPad(true);
    }
  });

  useEffect(() => {
    localRequest({
      method: 'post',
      url: `${process.env.REACT_APP_LOCAL_API}/resetStatus`,
      data: {},
    }).then(() => {});

    localRequest({
      method: 'get',
      url: `${process.env.REACT_APP_LOCAL_API}/getMachine`,
    })
      .then((res) => {
        console.log('getMachine', res.data);
        if (res.data?.themeColor?.oos) {
          let url = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${res.data?.themeColor?.oos}`;
          setContent(<img className="max_img" src={url} alt="out-of-stock"></img>);
        } else if (res.data?.themeColor?.oos_text) {
          setContent(<div className="out-of-stock">{res.data?.themeColor?.oos_text}</div>);
        }
      })
      .catch((err) => {});
  }, []);

  const handlepinpad = async (ping) => {
    if (ping === '98948') {
      localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/resetOutOfOrder`,
        data: {},
      }).then(() => {});
      setContent(
        <div className="out-of-stock">
          Please disable out of service in tech mode if needed, and re-entering to vending mode
        </div>
      );
      Swal.fire({
        title: 'Success',
        text: 'Please disable out of service in tech mode if needed, and re-entering to vending mode.',
        allowOutsideClick: false,
      }).then(() => {
        // history.push(linkToURL);
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Incorrect PIN',
        text: 'Please try again.',
        allowOutsideClick: false,
      });
    }
  };

  return (
    <div className="main-container">
      {/* Top-left corner trigger area that only activates for powerOption users */}
      {powerOption && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '50px',
            height: '50px',
            zIndex: 1000,
            // Uncomment for development visibility
            // backgroundColor: 'rgba(255, 0, 0, 0.2)'
          }}
          {...longPressEvent}
        />
      )}

      <div className="out-of-stock-div">
        {content}
        {powerOption && showPingPad && (
          <div className="out-of-stock-ping">
            <PingPad show={true} setShow={setShow} run={handlepinpad} />
          </div>
        )}
      </div>
    </div>
  );
}
